import { Row, Col, Container } from '@everlywell/leaves';
import { StatCard } from 'components/StatCard';
import React from 'react';
import { generateKey, sanitize } from 'utils/helpers';
import { IContentWithImage } from 'utils/types';

import SectionWrapper from '../../SectionWrapper';
import * as S from './styles';

export interface IStatisticsSection {
  backgroundColor: string;
  slug?: string;
  listOfContent?: IContentWithImage[];
  headline: string;
  disclaimer?: {
    disclaimer: string;
    childMarkdownRemark: {
      html: string;
    };
  };
}

export const StatisticsSection: React.FC<IStatisticsSection> = ({
  backgroundColor,
  slug,
  listOfContent,
  headline,
  disclaimer,
}) => (
  <SectionWrapper
    data-testid="statisticsSection"
    id={slug}
    backgroundColor={backgroundColor}
  >
    <Container>
      <Row center="xs">
        <Col xs={12} lg={12}>
          <S.SectionHeadline>{headline}</S.SectionHeadline>
          <S.StatsCardContainer>
            {listOfContent?.length
              ? listOfContent.map((content) => {
                  const image = content.image ? content.image.url : undefined;
                  const statImage =
                    content.image && image
                      ? {
                          gatsbyImageData: image,
                          title: content.image?.title,
                        }
                      : undefined;
                  return statImage ? (
                    <StatCard
                      heading={content.heading || ''}
                      content={content.description?.description || ''}
                      cta={
                        content.cta?.text && content.cta?.url
                          ? { text: content.cta.text, url: content.cta.url }
                          : undefined
                      }
                      statImage={
                        content.image?.url && content.image?.title
                          ? {
                              url: content.image.url,
                              title: content.image.title,
                            }
                          : undefined
                      }
                      key={generateKey()}
                    />
                  ) : (
                    <StatCard
                      heading={content.heading || ''}
                      content={content.description?.description || ''}
                      cta={
                        content.cta?.text && content.cta?.url
                          ? { text: content.cta.text, url: content.cta.url }
                          : undefined
                      }
                      key={generateKey()}
                    />
                  );
                })
              : null}
          </S.StatsCardContainer>
        </Col>
      </Row>
      {disclaimer?.childMarkdownRemark?.html && (
        <Row>
          <S.Description
            dangerouslySetInnerHTML={{
              __html: sanitize(disclaimer?.childMarkdownRemark.html),
            }}
          />
        </Row>
      )}
    </Container>
  </SectionWrapper>
);

export default StatisticsSection;
